import { ProductCategory, Tag } from '../types/yellowHiveTypes';
import { particulierSections } from './particulierData';
import { bedrijfsmatigSections } from './bedrijfsmatigData';

export const sections = [...particulierSections, ...bedrijfsmatigSections];

const TAG_NAME_MAP: Record<string, string> = {
  mkb: 'MKB',
  zzp: 'ZZP',
  transport: 'Transport',
  vastgoed: 'Vastgoed',
  vve: 'VvE',
};

export const getTagsForCategory = (category: ProductCategory): Tag[] => {
  const tagSet = new Set<string>();
  sections
    .filter((s) => s.products.some((p) => p.category === category))
    .forEach((section) => {
      section.products
        .filter((p) => p.category === category)
        .forEach((p) => p.tags.forEach((t) => tagSet.add(t)));
    });

  return Array.from(tagSet)
    .map((id) => ({
      id,
      name: TAG_NAME_MAP[id] || id.charAt(0).toUpperCase() + id.slice(1),
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};

// Backward compatibility default
export const tags: Tag[] = getTagsForCategory('Bedrijfsmatig');
